export default "__VITE_ASSET__Col8p$kj__"